import * as Sentry from '@sentry/react';
import {
  Route,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { useEffect } from 'react';

import config from '@occc/config';

// TODO: we should change the structure of our code and find a good place for this file
export const SentryRoute = Sentry.withSentryReactRouterV6Routing(Route);

export const initSentry = () => {
  const dsn = config.sentry;

  if (dsn) {
    Sentry.init({
      dsn,
      integrations: [
        Sentry.reactRouterV6BrowserTracingIntegration({
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
      ],
      tracesSampleRate: 0.5,
    });
  }
};
